const namespaceMembers = '[Members]';

export const MEMBERS_GET_ALL = `${namespaceMembers} MEMBERS GET ALL`;
export const MEMBERS_GET_ALL_FAILED = `${namespaceMembers} MEMBERS GET ALL FAILED`;
